import { ChainGrpcCommonTransformer } from '../client/chain/transformers/ChainGrpcCommonTransformer.js';
/**
 * @deprecated Use ChainGrpcCommonTransformer.pageRequestToGrpcPageRequest instead
 */
export const paginationRequestFromPagination = (pagination) => {
    return ChainGrpcCommonTransformer.pageRequestToGrpcPageRequest(pagination);
};
/**
 * @deprecated Use ChainGrpcCommonTransformer.paginationUint8ArrayToString instead
 */
export const paginationUint8ArrayToString = (key) => {
    return ChainGrpcCommonTransformer.paginationUint8ArrayToString(key);
};
/**
 * @deprecated Use ChainGrpcCommonTransformer.grpcPaginationToPagination instead
 */
export const grpcPaginationToPagination = (pagination) => {
    return ChainGrpcCommonTransformer.grpcPaginationToPagination(pagination);
};
export const grpcPagingToPaging = (pagination) => {
    if (!pagination) {
        return {
            to: 0,
            from: 0,
            total: 0,
        };
    }
    return {
        ...pagination,
        to: parseInt(pagination.to.toString() || '0', 10),
        from: parseInt(pagination.from.toString() || '0', 10),
        total: parseInt(pagination.total || '0', 10),
    };
};
export const fetchAllWithPagination = async (args, method, result = []) => {
    let response = await method(args);
    if (!args) {
        return response;
    }
    const keys = Object.keys(response);
    const valueKey = keys.find((key) => key !== 'pagination');
    result.push(...response[valueKey]);
    const paginationOption = args;
    if (response.pagination.next) {
        return fetchAllWithPagination({ ...paginationOption, key: response.pagination.next }, method, result);
    }
    return { [valueKey]: result, pagination: response.pagination };
};
